<template>
  <div class="helpHeader">
    <h1 v-if="breadcrumbs.length === 1" class="helpHeader_single-text">
      {{ breadcrumbs[0].text }}
    </h1>
    <v-breadcrumbs v-else :items="breadcrumbs">
      <template #divider>
        <v-icon size="22"> mdi-chevron-right </v-icon>
      </template>
      <template #item="{ item }">
        <v-breadcrumbs-item
          :to="item.to"
          :disabled="item.disabled"
          :link="item.link"
          class="helpHeader_breadcrumbs-item"
          :class="{ ['helpHeader_breadcrumbs-item--active']: item.active }"
        >
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
    <span class="helpHeader_subtitle">{{ desc }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'HelpHeader',
  data() {
    return {
      breadcrumbs: [],
      desc: '',
    };
  },
  computed: {
    ...mapState({
      helpCategories: (state) => state.help.categories,
    }),
    activeSetting() {
      return this.$route.params.parent;
    },
  },
  watch: {
    $route(to) {
      this.setBreadcrumbs(to);
    },
  },
  mounted() {
    this.setBreadcrumbs(this.$route);
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    setBreadcrumbs({ name, params, query }) {
      let breadcrumbs = [];
      if (name.startsWith('help')) {
        breadcrumbs.push({
          text: 'お問い合わせ',
          disabled: true,
          link: false,
        });

        const { id } = params;
        const category = this.helpCategories.find((c) => c.id === id);
        if (id) {
          breadcrumbs.push({
            text: category.title,
            disabled: false,
            to: { name: 'help-cat' },
            active: name === 'help-cat',
            link: true,
          });
          this.desc = category.Description;
        }

        const topicId = params.topic;
        if (topicId) {
          const topic = category.sub_topic.find((item) => item.id === topicId);
          breadcrumbs.push({
            text: topic.title,
            disabled: false,
            to: { name: 'help-cat-list', params: { topic: topicId }, query },
            active: name === 'help-cat-list',
            link: true,
          });
        }

        const questionId = params.qid;

        if (questionId) {
          const topic = category.sub_topic.find((item) => item.id === topicId);
          const questionIndex = topic.list.findIndex(
            (item) => item.id === questionId
          );
          if (questionIndex !== -1) {
            const question = topic.list[questionIndex];
            breadcrumbs.push({
              text: `Q${questionIndex + 1}\xa0\xa0\xa0   ${question.question}`,
              disabled: false,
              to: { name: 'help-cat-detail', params: { topic: topicId } },
              active: name === 'help-cat-detail',
              link: true,
            });
          }
          this.desc = '';
        }
      }
      if (name === 'help-confirm') {
        breadcrumbs = [
          {
            text: 'お問い合わせ内容の確認',
            disabled: false,
            to: { name: 'help-cat-confirm' },
            active: true,
            link: true,
          },
        ];
        this.desc = '';
      }
      if (name === 'help-email') {
        breadcrumbs = [
          {
            text: 'メールを送信しました',
            disabled: false,
            to: { name: 'help-email' },
            active: true,
            link: true,
          },
        ];
        this.desc = '';
      }
      if (name === 'help-cam-select') {
        breadcrumbs.push({
          text: 'ご質問対象のカメラ',
          disabled: false,
          to: { name: 'help-cam-select' },
          active: true,
          link: true,
        });
        this.desc = 'ご質問対象のカメラをカメラ一覧から選択';
      }
      this.breadcrumbs = breadcrumbs;
    },
  },
};
</script>

<style lang="scss">
.helpHeader {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  color: var(--text-color);
  max-width: 966px;

  &_single-text {
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #4b4b4b;
    margin: 5px 0;
  }
  &_breadcrumbs-item {
    &--active {
      a {
        font-size: 20px !important;
        font-weight: bold !important;
        color: #4b4b4b !important;
      }
    }
    a {
      &.v-breadcrumbs__item {
        line-height: 2;
      }
    }
  }
  &_text {
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #4b4b4b;
  }
  &_type {
    color: var(--warning-color-lighten1);
    font-size: 12px;
    font-weight: 600;
  }
  .v-breadcrumbs__divider {
    padding: 0 5px !important;
    .theme--light.v-icon {
      color: #989898;
    }
  }
  .v-breadcrumbs {
    padding: 0;
  }
  .theme--light.v-breadcrumbs .v-breadcrumbs__divider,
  .theme--light.v-breadcrumbs .v-breadcrumbs__item--disabled {
    color: #4b4b4b;
    font-weight: normal;
    pointer-events: all;
    cursor: pointer;
  }
  .v-breadcrumbs__item {
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #4b4b4b;
    font-size: 20px;
  }
  &_subtitle {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #989898;
  }
}
</style>
